import React from "react";
import RestrictedWebhookOptionWrapper from "../../RestrictedWebhookOptionWrapper";
import { SelectedWebhookType } from "../../../enums";
import AsyncBulkPostIcon from "../../../../../../../../assets/svg/async_bulk_post.svg";
import WebhookSelectCard from "./WebhookSelectCard";

interface AsyncBulkPostWebhookProps {
  onSelectedWebhookTypeChange: (selectedWebhookType: SelectedWebhookType) => void;
  selectedWebhookType: Set<SelectedWebhookType>;
  onUnselectingWebhookType: (selectedWebhookType: SelectedWebhookType) => void;
}

function AsyncBulkPostWebhook(props: AsyncBulkPostWebhookProps) {
  const { onSelectedWebhookTypeChange, selectedWebhookType, onUnselectingWebhookType } = props;
  const selected = selectedWebhookType
    ? selectedWebhookType.has(SelectedWebhookType.ASYNC_BULK_POST)
    : false;

  return (
    <RestrictedWebhookOptionWrapper>
      <WebhookSelectCard
        title="Async Bulk Post completed"
        description="Receive an alert when an async bulk POST has resolved"
        icon={<img src={AsyncBulkPostIcon} width={16} height={16} alt="Async Bulk Post" />}
        onClick={() => {
          if (selected) {
            onUnselectingWebhookType(SelectedWebhookType.ASYNC_BULK_POST);
          } else {
            onSelectedWebhookTypeChange(SelectedWebhookType.ASYNC_BULK_POST);
          }
        }}
        selected={selected}
        selectedWebhookType={selectedWebhookType}
      />
    </RestrictedWebhookOptionWrapper>
  );
}

export default AsyncBulkPostWebhook;
